Scenario history answers whether this is a regression, chronic flake, or one-off.
Materialization fetches recent history for the selected failed/flaky scenarios.

Compare:

  - the last green revision and timestamp;
  - whether the same step failed previously;
  - whether failures alternate with passes (flakiness);
  - whether a failure began after a product or test-source change;
  - whether historical failures coincide with lifecycle timeouts.

History is supporting evidence, not proof. A previously green test can still
contain a latent test bug, and a newly failing test can expose a real regression.
